import axios from 'axios';
import { environment } from '../../../containers/environment';
import { history } from "../../../../src/shared/history";
import { findAllPermissions } from "../../../containers/Services/SecurityService";
import Cookies from 'universal-cookie';

//const qs = require('querystring')
const cookies = new Cookies();
const urlAPI = environment.URL_API;
const urlAUTH = environment.HOST_AUTH;
const urlLogin = environment.TOKEN_URL;
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
}

export const useBasicAuth = {
    login,
    logout,
    resetPassword,
    redirectToLogin,
    redirectToHome,
    redirectSearch,
    redirectChat,
    redirectToDenied,
    redirectTo404,
    getUrl,
    checkToken,
    checkTokenExists,
    checkTokenSidebar,
    addInterval,
    clearIntervals,
    handleError,
    handleErrorLogin,
    userInfo,
    createRememberMeToken,
    removeCookies,
    isRememberMeEnabled,
    loginWithRememberMeToken
};

function login(email, password, rememberMe, callback) {
    const requestBody = {
        email: email,
        password: password
    }

    if (email === null || email === undefined || email === '' ||
        password === null || password === undefined || password === '') {
        callback("loginFieldsError");
        return;
    }

    axios.post(urlLogin, requestBody, config).then(result => {
        if (result.status === 200) {
            localStorage.setItem(environment.TOKEN_KEY, result.headers.authorization.replace("Bearer ", ""));

            console.log("Logado!!");

            // axios.get(urlAPI + "auth/user/info", {
            axios.get(urlAUTH + "auth/user/info", {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                }
            }).then(result => {

                if (result.status === 200) {

                    axios.get(urlAPI + "api/users/" + result.data.id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                        }
                    }).then(result => {

                        if (result.status === 200) {
                            if (result.data.deleted) {
                                this.logout();
                                return this.handleErrorLogin('excluido', callback);
                            } else if (result.data.status !== "ATIVO") {
                                this.logout();
                                return this.handleErrorLogin('inativo', callback);
                            } else {
                                //TODO ajustar
                                localStorage.setItem(environment.TOKEN_ROLES, "W8594HSDHW" + (result.data.role.replace("ROLE_", "UTJ2e73DdKTThIAG") + "VsTaS1zk4DJ"));

                                let user = {
                                    id: result.data.id,
                                    email: result.data.email,
                                    firstName: result.data.firstName,
                                    lastName: result.data.lastName,
                                    name: result.data.name,
                                    cidade: result.data.cidade,
                                    role: result.data.role,
                                    permissions: [],
                                    groups: [],
                                    orgaos: []
                                }

                                axios.get(urlAPI + "api/security/getPermissions/" + result.data.id, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept': 'application/json',
                                        'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                                    }
                                })
                                    .then(result => {

                                        if (result.status === 200) {
                                            if (result.data != null && result.data != undefined) {
                                                if (result.data.permissions != null) {
                                                    user.permissions = result.data.permissions
                                                }
                                                if (result.data.groups != null) {
                                                    user.groups = result.data.groups
                                                }
                                            }
                                            //VALIDAR USER PREFEITURAS
                                            if (user.groups.length > 0 && (user.groups.includes("PREFEITURAS") || user.groups.includes("PREFEITURAS_ADMINISTRADORES"))) {

                                                axios.get(urlAPI + "api/security/getOrgaos/" + user.id, {
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'Accept': 'application/json',
                                                        'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                                                    }
                                                })
                                                    .then(result => {

                                                        if (result.status === 200) {
                                                            if (result.data != null && result.data != undefined) {
                                                                if (result.data.valid || user.groups.includes("PREFEITURAS_ADMINISTRADORES")) {

                                                                    if (result.data.orgaoList !== null) {
                                                                        for (let i = 0; i < result.data.orgaoList.length; i++) {
                                                                            user.orgaos.push(result.data.orgaoList[i]);
                                                                        }
                                                                    }

                                                                    localStorage.setItem(environment.DATA_USER, JSON.stringify(user));

                                                                    if (rememberMe) {
                                                                        this.createRememberMeToken();
                                                                    } else {
                                                                        this.redirectToHome();
                                                                    }

                                                                } else {
                                                                    return this.handleErrorLogin('inativo', callback);
                                                                }
                                                            } else {
                                                                return this.handleErrorLogin(null, callback);
                                                            }
                                                        } else {
                                                            return this.handleErrorLogin(null, callback);
                                                        }
                                                    }).catch(e => {
                                                        return this.handleErrorLogin(e, callback);
                                                    });

                                            } else {
                                                localStorage.setItem(environment.DATA_USER, JSON.stringify(user));

                                                if (rememberMe) {
                                                    this.createRememberMeToken();
                                                } else {
                                                    this.redirectToHome();
                                                }
                                            }

                                        } else {
                                            return this.handleErrorLogin(null, callback);
                                        }
                                    }).catch(e => {
                                        return this.handleErrorLogin(e, callback);
                                    });
                            }

                        } else {
                            return this.handleErrorLogin(null, callback);
                        }
                    }).catch(e => {
                        return this.handleErrorLogin(e, callback);
                    });

                } else {
                    return this.handleErrorLogin(null, callback);
                }
            }).catch(e => {
                return this.handleErrorLogin(e, callback);
            });

        } else {
            return this.handleErrorLogin(null, callback);
        }
    }).catch(e => {
        return this.handleErrorLogin(e, callback);
    });

};

//TODO ajustar
function resetPassword(email, callback) {
    const requestBody = {
        email: email
    }

    if (email === null || email === undefined || email === '') {
        callback("resetPasswordError");
        return;
    }

    axios.post(urlAUTH + "auth/user/resetpassword", requestBody, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.TOKEN_RESET_PASSWORD,
        }
    }).then(result => {
        if (result.status === 200) {
            console.log(result);

            callback("resetPasswordMsg");

        } else {
            callback("otherError");
        }
    }).catch(e => {
        callback("otherError");
    });
};

function createRememberMeToken() {
    axios.get(urlAUTH + "auth/user/rememberme", {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
        }
    }).then(result => {
        if (result.status === 200) {
            cookies.set(environment.TOKEN_KEY_REMEMBER_ME, result.data.rememberMe, { secure: true, path: '/', sameSite: 'none' });
            this.redirectToHome();
        }
    }).catch(e => {
        this.removeCookies();
    });
}

function isRememberMeEnabled() {
    if (cookies.get(environment.TOKEN_KEY_REMEMBER_ME) !== null &&
        cookies.get(environment.TOKEN_KEY_REMEMBER_ME) !== undefined) {
        return true;
    }
    return false;
}

function loginWithRememberMeToken(cameFromhandleError) {
    let token = cookies.get(environment.TOKEN_KEY_REMEMBER_ME);
    const requestBody = {
        token: token
    }

    axios.post(urlAUTH + "auth/user/remembermeuser", requestBody, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token,
        }
    }).then(result => {
        if (result.status === 200) {
            localStorage.setItem(environment.TOKEN_KEY, result.data.tokenRefresh.replace("Bearer ", ""));

            axios.get(urlAPI + "api/users/" + result.data.id, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                }
            }).then(result => {

                if (result.status === 200) {
                    if (result.data.deleted) {
                        this.logout();
                        return this.handleErrorLogin('excluido', null);
                    } else if (result.data.status !== "ATIVO") {
                        this.logout();
                        return this.handleErrorLogin('inativo', null);
                    } else {
                        //TODO ajustar
                        localStorage.setItem(environment.TOKEN_ROLES, (result.data.role.replace("ROLE_", "UTJ2e73DdKTThIAG") + "VsTaS1zk4DJ"));

                        let user = {
                            id: result.data.id,
                            email: result.data.email,
                            firstName: result.data.firstName,
                            lastName: result.data.lastName,
                            name: result.data.name,
                            cidade: result.data.cidade,
                            role: result.data.role,
                            permissions: [],
                            groups: [],
                            orgaos: []
                        }

                        axios.get(urlAPI + "api/security/getPermissions/" + result.data.id, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                            }
                        })
                            .then(result => {
                                if (result.status === 200) {
                                    if (result.data != null && result.data != undefined) {
                                        if (result.data.permissions != null) {
                                            user.permissions = result.data.permissions
                                        }
                                        if (result.data.groups != null) {
                                            user.groups = result.data.groups
                                        }
                                    }
                                    //VALIDAR USER PREFEITURAS
                                    if (user.groups.length > 0 && (user.groups.includes("PREFEITURAS") || user.groups.includes("PREFEITURAS_ADMINISTRADORES"))) {

                                        axios.get(urlAPI + "api/security/getOrgaos/" + user.id, {
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Accept': 'application/json',
                                                'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
                                            }
                                        })
                                            .then(result => {
                                                if (result.status === 200) {
                                                    if (result.data != null && result.data != undefined) {
                                                        if (result.data.valid) {

                                                            for (let i = 0; i < result.data.orgaoList.length; i++) {
                                                                user.orgaos.push(result.data.orgaoList[i]);
                                                            }

                                                            localStorage.setItem(environment.DATA_USER, JSON.stringify(user));


                                                            if (cameFromhandleError) {
                                                                window.location.reload(false);
                                                            } else {
                                                                this.redirectToHome();
                                                            }

                                                        }
                                                    }
                                                }
                                            }).catch(e => {
                                            });

                                    } else {
                                        localStorage.setItem(environment.DATA_USER, JSON.stringify(user));

                                        if (cameFromhandleError) {
                                            window.location.reload(false);
                                        } else {
                                            this.redirectToHome();
                                        }
                                    }

                                }
                            }).catch(e => {
                            });
                    }

                }
            }).catch(e => {
            });
        }

        this.logout()();
        this.redirectToLogin();

    }).catch(e => {
        this.logout();
        this.redirectToLogin();
    });
}

function userInfo() {
    axios.get(urlAUTH + "auth/user/info", {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem(environment.TOKEN_KEY)
        },
    })
        .then(result => {
            //console.log(result);
            // if (result.status === 200) {
            //   console.log(result);
            // } else {
            //    console.log("else: " + result)
            // }
        }).catch(e => {
            //console.log("catch userInfo: " + e)
        });
}

function checkTokenSidebar() {
    if (localStorage.getItem(environment.TOKEN_KEY) === null) {
        this.redirectToLogin();
    }
    return true;
}

function checkToken() {
    if (localStorage.getItem(environment.TOKEN_KEY) === null) {
        this.redirectToLogin();
    }
    return true;
}

function checkTokenExists() {
    if (localStorage.getItem(environment.TOKEN_KEY) === null) {
        return false;
    }
    return true;
}

function handleError(error) {
    //console.log(window.location.href);
    //console.log("handleError: ");
    //console.log(error);
    if (error.toString().includes('401')) {//Unauthorized
        if (this.isRememberMeEnabled()) {
            this.loginWithRememberMeToken(true);
        } else {
            this.redirectToLogin();
        }
    } else if (error.toString().includes('403')) {//Forbidden
        this.redirectToDenied();
    } else if (error.toString().includes('Network Error')) {//ERR_CONNECTION_REFUSED
        this.redirectTo404();
    } else {
        //return error.response.data;
        this.redirectTo404();
    }
}

function handleErrorLogin(error, callback) {
    // console.log("handleErrorLogin: ");
    // console.log(error);
    if (error !== null && error !== undefined) {
        if (error.toString().includes('400') || error.toString().includes('401') ||
            error.toString().includes('excluido') || error.toString().includes('inativo')) {
            callback("unauthorized");
            return;
        } else {
            callback("otherError");
        }
    } else {
        callback("otherError");
    }
}

function redirectToLogin() {
    history.redirect('/log_in');
}

function redirectToHome() {
    if (environment.isAdmin()) {
        history.redirect('/forms/home');
    } else {
        history.redirect('/forms/home');
    }
}

function redirectTo404() {
    history.redirect('/404');
}

function redirectSearch(processo) {
    history.redirect('/forms/proccess/' + processo);
}

function redirectChat(contact) {
    localStorage.setItem(environment.CHAT_CONTACT, contact);
    history.redirect('/forms/chat/');
}

function redirectToDenied() {
    history.redirect('/forms/denied');
}

function getUrl() {
    return window.location.pathname;
}

function getIntervals() {
    let intervals = localStorage.getItem(environment.INTERVAL);
    if (intervals === null) {
        intervals = [];
    } else {
        intervals = JSON.parse(intervals);
    }
    return intervals;
}

function addInterval(key, id) {
    let exists = false;
    let intervals = getIntervals();
    let interval = {
        key: key,
        id: id
    };
    for (let index = 0; index < intervals.length; index++) {
        if (intervals[index].key === key) {
            exists = true;
            if (intervals[index].id !== id) {
                clearInterval(intervals[index].id);
                intervals[index].id = id;
            }
            break;
        }
    }
    if (!exists) {
        intervals.push(interval);
    }
    localStorage.setItem(environment.INTERVAL, JSON.stringify(intervals));
}

function clearIntervals(all = false, key = null) {
    let intervals = getIntervals();
    if (intervals.length > 0) {
        if (all) {
            for (let index = (intervals.length - 1); index >= 0; index--) {
                clearInterval(intervals[index].id);
                intervals.splice(index, 1);
            }
            localStorage.removeItem(environment.INTERVAL);
        } else if (key !== null) {
            for (let index = 0; index < intervals.length; index++) {
                if (intervals[index].key === key) {
                    clearInterval(intervals[index].id);
                    intervals.splice(index, 1);
                    localStorage.setItem(environment.INTERVAL, JSON.stringify(intervals));
                    break;
                }
            }
        }
    }
}

function logout() {

    clearIntervals(true, null);

    localStorage.removeItem(environment.TOKEN_KEY);
    localStorage.removeItem(environment.TOKEN_ROLES);
    localStorage.removeItem(environment.DATA_USER);
    localStorage.removeItem(environment.STATE_FILTER);
    localStorage.removeItem(environment.CITY_FILTER);
    removeCookies();
}

function removeCookies() {
    cookies.remove(environment.TOKEN_KEY_REMEMBER_ME);
}